import { ColumnEditorOptions } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { useState } from "react";
import {
    formatCalendarDate,
    parseCalendarDate
} from "@idwal/checklist-visibility";

interface DateEditorProps {
    options: ColumnEditorOptions;
}

// Format a stored calendar date for the reviewer, who reads dd/mm/yyyy.
const formatDisplayDate = (date: Date | null): string => {
    if (!date) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");

    return `${day}/${month}/${date.getFullYear()}`;
};

export const DateEditor = ({ options }: DateEditorProps) => {
    // Seed once so the existing date shows on open and survives re-renders.
    const [date, setDate] = useState<Date | null>(() =>
        parseCalendarDate(options.value)
    );

    const handleChange = (value: Nullable<Date>) => {
        setDate(value ?? null);
        options.editorCallback?.(formatCalendarDate(value));
    };

    return (
        <Calendar
            value={date}
            onChange={(e) => handleChange(e.value)}
            dateFormat="dd/mm/yy"
            showIcon
            autoFocus
        />
    );
};

export const dateDisplayTemplate = (value: unknown): string => {
    if (!value) return "";

    const date = parseCalendarDate(value);
    if (!date) return String(value);

    return formatDisplayDate(date);
};
